import React, { useEffect, useState } from "react";
import { Row, DatePicker, Table } from "antd";
import "../../styles/filters-form.less";
import "./CrossCurrencies.less";
import moment from "moment";
import { displayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";

import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import { fetchCurrenciesCrossRates } from "../../store/slices/currencies";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import { useAppDispatch, useAppSelector } from "../..";

const dateFormat = displayFormat;
const enCollator = new Intl.Collator("en-US");

const CrossCurrencies = ({ dicCurrencies, dicCurrenciesLoading }) => {
  const dispatch = useAppDispatch();
  const nowDate = moment();

  const { currenciesCrossRatesData, currenciesCrossRatesDataLoading } = useAppSelector(
    (state) => state.currencies
  );

  const [crossCurrenciesDate, setCrossCurrenciesDate] = useState(nowDate);

  useEffect(() => {
    dispatch(fetchCurrenciesCrossRates(toHttpFormatStartOfDay(crossCurrenciesDate)));
  }, [crossCurrenciesDate]);

  const isLoaded = checkIsLoaded(dicCurrenciesLoading, currenciesCrossRatesDataLoading);

  let tableData;

  // Функция сортировки
  const crossRatesCompareSorted = (a, b) => {
    if (a === "USD" && b === "EUR") return -1;
    if (a === "USD" && b !== "EUR") return -1;
    if (a === "EUR" && b !== "USD") return -1;
    if (a === "EUR" && b === "USD") return 1;
    if (a !== "USD" && b === "EUR") return 1;
    if (a !== "EUR" && b === "USD") return 1;
    return enCollator.compare(a, b);
  };

  if (checkIsLoaded(currenciesCrossRatesDataLoading)) {
    const formatedCurrenciesCrossRates = [];
    if (Array.isArray(currenciesCrossRatesData)) {
      currenciesCrossRatesData.forEach((item) => {
        // Получение abbrev дочернего статуса
        const abbrevQuotedFind = dicCurrencies.find(
          (currency) => currency.id === item?.quotedCurrencyId
        )?.abbrev;

        // Проверка есть ли такой родительский abbrev уже в массиве
        const findIndexCurrencies = formatedCurrenciesCrossRates.findIndex(
          (el) => el.key === item.basicCurrencyId
        );

        if (findIndexCurrencies === -1) {
          // Получение abbrev родительского статуса
          const basicAbbrevFind = dicCurrencies.find(
            (currency) => currency.id === item?.basicCurrencyId
          )?.abbrev;
          // Создаём родительский abbrev с курсом дочернего abbrev
          formatedCurrenciesCrossRates.push({
            key: item.basicCurrencyId,
            name: basicAbbrevFind,
            [`${abbrevQuotedFind}`]: item.rate,
          });
        } else {
          // Добавляем к родительскому abbrev курс ещё одного дочернего abbrev
          formatedCurrenciesCrossRates[findIndexCurrencies] = {
            ...formatedCurrenciesCrossRates[findIndexCurrencies],
            [`${abbrevQuotedFind}`]: item.rate,
          };
        }

        // Сортируем чтобы доллар и евро были в начале, а остальные по алфавиту
        const arrSorted = formatedCurrenciesCrossRates.sort((a, b) =>
          crossRatesCompareSorted(a.name, b.name)
        );

        tableData = arrSorted;
      });
    }
  }

  const getColumns = () => [
    {
      title: "",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (value) => ({
        props: {
          style: { color: "#8a99a8" },
        },
        children: <span>{value}</span>,
      }),
    },
    ...dicCurrencies
      .map(({ id, abbrev }) => ({
        title: abbrev,
        dataIndex: abbrev,
        key: id,
        align: "center",
        render: (value) => ({
          props: {
            style: { background: value === 1 && "#f0fdff" },
          },
          children: <span>{!value ? "-" : value !== 1 && value}</span>,
        }),
      }))
      .sort((a, b) => crossRatesCompareSorted(a.title, b.title)),
  ];

  const [columns, setColumns] = useState(getColumns());

  useEffect(() => {
    setColumns((prev) => {
      const newColumns = getColumns().map((column, i) => ({
        ...column,
        hidden: prev[i]?.hidden,
      }));
      return newColumns;
    });
  }, [dicCurrencies]);

  return (
    <div className="inner-row cross-currency-table">
      <Row justify="space-between" align="middle">
        <div>
          <label style={{ paddingRight: "15px" }}>Дата:</label>
          <DatePicker
            allowClear={false}
            style={{ minWidth: "140px" }}
            format={dateFormat}
            disabledDate={(current) => current && current.isAfter()}
            value={crossCurrenciesDate}
            onChange={(date) => {
              setCrossCurrenciesDate(date);
            }}
          />
        </div>
        <ToggleColumns
          tableName="account-bills-table"
          indexColHiddenForCheckAll={1}
          columns={columns}
          setColumns={setColumns}
        />
      </Row>

      <Table
        className="version-table currency-version-table"
        size="small"
        columns={columns.filter(({ hidden }) => !hidden)}
        dataSource={tableData}
        pagination={false}
        loading={!isLoaded}
      />
    </div>
  );
};

export default CrossCurrencies;
